// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify'

// This imports ALL Vuetify styles
import 'vuetify/dist/vuetify.min.css'

// This imports material design icons (optional)
import '@mdi/font/css/materialdesignicons.min.css'

// This registers Vuetify globally
Vue.use(Vuetify)

// Create and export the Vuetify instance
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi', // Using Material Design Icons
  },
  theme: {
    themes: {
      light: {
        primary: '#882182',
        secondary: '#f36247',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  }
})

export default vuetify